import PropTypes from "prop-types";
import React, { useMemo } from "react";
import { SharedLineItemsTable, createHiddenGroupingColumns } from "./SharedLineItemsTable";
import { createBaseColumns, createPurchaseOrderAdditionalColumns } from "./sharedTableColumns";
import { createBaseDataRow, useLineItemsTableHandlers } from "./useLineItemsTableHandlers";

const PurchaseOrderLineItemsTable = ({
  rows,
  onRowsChange,
  onFormDataChange,
  dropdownOptions,
  getDisplayText,
}) => {
  const defaultRowFields = {
    changeEvent: "",
    budgetCodeId: "",
    description: "",
    qty: "",
    uom: "",
    unitCost: "",
    amount: "",
    billed: "",
    remaining: "",
  };

  const { handleEdit, handleAddRow, handleRemoveRow } = useLineItemsTableHandlers(
    rows,
    onRowsChange,
    onFormDataChange,
    defaultRowFields
  );

  const data = useMemo(
    () =>
      rows.map((row, idx) => {
        const baseRow = createBaseDataRow(row, idx, dropdownOptions, getDisplayText);
        return {
          ...baseRow,
          qty: row.qty || "",
          uom: row.uom || "",
          unitCost: row.unitCost || "",
        };
      }),
    [rows, dropdownOptions, getDisplayText]
  );

  const columns = useMemo(() => {
    const baseCols = createBaseColumns(
      handleEdit,
      handleRemoveRow,
      dropdownOptions,
      getDisplayText
    );
    const purchaseOrderCols = createPurchaseOrderAdditionalColumns(
      handleEdit,
      dropdownOptions,
      getDisplayText
    );
    // Insert purchase order columns after description and before amount
    const amountIndex = baseCols.findIndex((col) => col.accessorKey === "amount");
    const visibleColumns = [
      ...baseCols.slice(0, amountIndex),
      ...purchaseOrderCols,
      ...baseCols.slice(amountIndex),
    ];
    const hiddenGroupingCols = createHiddenGroupingColumns();
    return [...visibleColumns, ...hiddenGroupingCols];
  }, [handleEdit, dropdownOptions, getDisplayText, handleRemoveRow]);

  return <SharedLineItemsTable columns={columns} data={data} onAddRow={handleAddRow} />;
};

PurchaseOrderLineItemsTable.propTypes = {
  rows: PropTypes.array.isRequired,
  onRowsChange: PropTypes.func.isRequired,
  onFormDataChange: PropTypes.func.isRequired,
  dropdownOptions: PropTypes.object.isRequired,
  getDisplayText: PropTypes.func.isRequired,
};

export default PurchaseOrderLineItemsTable;
